import React, { useState } from 'react'
import { XDivider } from '../../assets/imgs/svg/AnimeGlossary/XDivider'
import { postListImages } from '../../services/images.service'
import glossaryData from '../../assets/jsons/glossary.json'
import { AnimeGlossaryHelmet } from '../../cmps/Helments/AnimeGlossaryHelmet'

export function AnimeGlossary() {
  // רשימת האותיות – ניתן לשנות את הסדר לפי הצורך
  const letters = [
    'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 
    'מ', 'ל', 'כ', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א'
  ]
  
  // state לניהול האות הנבחרת, ערך החיפוש והמילה הנבחרת מהרשימה
  const [selectedLetter, setSelectedLetter] = useState('א')
  const [searchInput, setSearchInput] = useState('')
  const [selectedTerm, setSelectedTerm] = useState(null)

  // סינון ראשוני – מילים המתחילות באותה אות
  const termsByLetter = glossaryData.terms.filter(term =>
    term.term.startsWith(selectedLetter)
  )

  // סינון נוסף – לפי ערך החיפוש, אם קיים
  const filteredTerms = searchInput
    ? termsByLetter.filter(term =>
        term.term.includes(searchInput)
      )
    : termsByLetter

  // במידה ויש מילה נבחרת – נביא אותה לראש הרשימה
  const displayedTerms = selectedTerm
    ? [selectedTerm, ...filteredTerms.filter(term => term.term !== selectedTerm)]
    : filteredTerms

  // Handlers
  const handleLetterClick = (letter) => {
    setSelectedLetter(letter)
    setSearchInput('')
    setSelectedTerm(null)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value)
    setSelectedTerm(null)
  }


  const handleClearSearch = () => {
    setSearchInput('')
    setSelectedTerm(null)
  }

  return (
    <section className="container mx-auto p-4">
      <AnimeGlossaryHelmet/>
      <div className="relative flex flex-col items-center justify-center">
        <h1 className="text-5xl">מילון מושגים</h1>
        <div className="flex gap-3 mt-4">
          <h5 className="cursor-pointer">חיפוש במושגים קיימים</h5>
          <span>/</span>
          <h5 className="cursor-pointer">חיפוש עם בינה מלאכותית</h5>
        </div>

        {/* טופס חיפוש */}
        <form
          onSubmit={(e) => e.preventDefault()}
          className="w-[541px] flex items-center bg-[#424242] mt-4 relative"
        >
          <div className="flex items-center ps-3">
            <img src={postListImages.searchIcon} alt="Search Icon" />
          </div>
          <input
            type="text"
            id="searchInput"
            name="searchInput"
            value={searchInput}
            onChange={handleSearchChange}
            className="flex-1 ps-3 text-lg bg-transparent focus:outline-none text-white"
            placeholder="חיפוש"
          />
          {searchInput && (
            <button
              type="button"
              onClick={handleClearSearch}
              className="ml-2 p-2 bg-red-500 text-white rounded"
            >
              נקה חיפוש
            </button>
          )}
          <button type="submit" title="Search Button" className="relative">
            <img src={postListImages.searchBtn} alt="Search Button" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              חיפוש
            </span>
          </button>
        </form>

        {/* רשימת אותיות – מוצגת למעלה */}
        <div className="flex flex-row-reverse justify-center items-center gap-8 mt-10">
        {letters.map((char, index) => (
          <div
            key={index}
            className={`cursor-pointer font-noa text-2xl ${
              selectedLetter === char ? 'w-14 h-14 flex items-center justify-center bg-primary overflow-hiddentext-center text-white' : 'text-white'
            }`}
            onClick={() => handleLetterClick(char)}
          >
            {char}
          </div>
        ))}
        </div>
      </div>

      {/* תצוגת מילים */}
      <div className="mt-10">
        <div className="flex justify-between items-center">
          <h5 className="text-muted text-lg font-yarden">
            {displayedTerms.length} מושגים
          </h5>
        </div>
        <div>
          {displayedTerms.map((term, index) => (
            <div key={index} className="flex flex-col gap-8 my-10">
              <div className="flex gap-3 text-3xl">
                <h3 className="text-white">{term.term}</h3>
                {term.transliteration && (
                  <h3 className="text-white">({term.transliteration})</h3>
                )}
              </div>
              <div>
                <p className="text-lg">- {term.definition}</p>
              </div>
              <XDivider />
            </div>
          ))}
        </div>
      </div>

      {/* רשימת אותיות – מוצגת בתחתית */}
      <div className="flex flex-row-reverse justify-center items-center gap-8 mt-10">
        {letters.map((char, index) => (
          <div
            key={index}
            className={`cursor-pointer font-noa text-2xl ${
              selectedLetter === char ? 'w-14 h-14 flex items-center justify-center bg-primary overflow-hiddentext-center text-white' : 'text-white'
            }`}
            onClick={() => handleLetterClick(char)}
          >
            {char}
          </div>
        ))}
      </div>
    </section>
  )
}
